(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-announce')) {
    customElements.define(
      'zv-announce',
      class ZVAnnounce extends HTMLElement {
        connectedCallback() {
          const start = () => {
            const msgs = [...this.querySelectorAll('.zv-announce__msg')].filter((m) => getComputedStyle(m).display !== 'none');
            if (msgs.length && !msgs.some((m) => m.classList.contains('is-active'))) msgs[0].classList.add('is-active');
            if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            let i = 0;
            const ms = Math.max(2000, parseInt(this.dataset.interval, 10) || 5000);
            this.timer = setInterval(() => {
              msgs[i].classList.remove('is-active');
              i = (i + 1) % msgs.length;
              msgs[i].classList.add('is-active');
            }, ms);
          };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
          else start();
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-concerns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-zv-concerns]').forEach((list) => {
      const root = list.closest('.zv-concerns');
      const imgs = root.querySelectorAll('[data-zv-concern-img]');
      if (!imgs.length) return;
      const show = (i) => imgs.forEach((img) => img.classList.toggle('is-active', img.dataset.zvConcernImg === String(i)));
      show(0);
      list.querySelectorAll('[data-zv-concern]').forEach((a) => {
        a.addEventListener('mouseenter', () => show(a.dataset.zvConcern));
        a.addEventListener('focus', () => show(a.dataset.zvConcern));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-header"]) return;
  try {
    
  if (!customElements.get('zv-header')) {
    customElements.define(
      'zv-header',
      class ZVHeader extends HTMLElement {
        connectedCallback() {
          if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
          else this.init();
        }

        init() {
          this.sticky = this.dataset.sticky;
          this.lastY = window.scrollY;
          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
          this.bindMega();
          this.bindDialogs();

          // Fall back to the menu button when the links do not fit (long translations, narrow laptops)
          this.fit = this.fit.bind(this);
          this.fit();
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fit);
          let raf;
          window.addEventListener('resize', () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(this.fit);
          });
        }

        fit() {
          this.classList.remove('is-tight');
          if (!window.matchMedia('(min-width: 1180px)').matches) return;
          const list = this.querySelector('.zv-nav__list');
          const end = this.querySelector('.zv-header__end');
          const logo = this.querySelector('.zv-logo');
          if (!list || !end || !logo) return;
          const r = list.getBoundingClientRect();
          const tooWide = r.right > end.getBoundingClientRect().left - 16 || r.left < logo.getBoundingClientRect().right + 16;
          this.classList.toggle('is-tight', tooWide);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }

        onScroll() {
          const y = window.scrollY;
          this.classList.toggle('is-stuck', y > 8);
          this.classList.toggle('is-compact', y > 70);
          if (this.sticky === 'scroll-up') {
            const goingDown = y > this.lastY;
            const anyOpen = this.querySelector('.zv-mega.is-open');
            if (y > 260 && goingDown && !anyOpen) this.classList.add('is-hidden');
            else if (!goingDown) this.classList.remove('is-hidden');
          }
          this.lastY = y;
          document.documentElement.classList.toggle('zv-header-hidden', this.classList.contains('is-hidden'));
        }

        bindMega() {
          const items = this.querySelectorAll('.zv-nav__item--mega');
          const closeAll = () =>
            items.forEach((item) => {
              item.querySelector('[data-zv-mega]').classList.remove('is-open');
              item.querySelector('[data-zv-mega-trigger]').setAttribute('aria-expanded', 'false');
            });
          const open = (item) => {
            closeAll();
            item.querySelector('[data-zv-mega]').classList.add('is-open');
            item.querySelector('[data-zv-mega-trigger]').setAttribute('aria-expanded', 'true');
          };
          let timer;
          items.forEach((item) => {
            const trigger = item.querySelector('[data-zv-mega-trigger]');
            item.addEventListener('mouseenter', () => {
              clearTimeout(timer);
              timer = setTimeout(() => open(item), 90);
            });
            item.addEventListener('mouseleave', () => {
              clearTimeout(timer);
              timer = setTimeout(closeAll, 140);
            });
            trigger.addEventListener('click', (e) => {
              const isOpen = trigger.getAttribute('aria-expanded') === 'true';
              if (window.matchMedia('(hover: none)').matches) {
                if (!isOpen) {
                  e.preventDefault();
                  open(item);
                }
              }
            });
            trigger.addEventListener('keydown', (e) => {
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                open(item);
                item.querySelector('[data-zv-mega] a')?.focus();
              }
            });
            item.addEventListener('focusout', (e) => {
              if (!item.contains(e.relatedTarget)) closeAll();
            });
          });
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeAll();
          });
          document.addEventListener('click', (e) => {
            if (!e.target.closest('.zv-nav__item--mega')) closeAll();
          });
        }

        bindDialogs() {
          const root = this.closest('.shopify-section') || document;
          document.querySelectorAll('[data-zv-open]').forEach((btn) => {
            if (btn.__zvBound) return;
            btn.__zvBound = true;
            btn.addEventListener('click', () => {
              const target = document.getElementById(btn.dataset.zvOpen);
              if (!target || !window.ZV) return;
              if (btn.hasAttribute('data-zv-swap')) {
                const from = btn.closest('dialog');
                if (from) {
                  from.classList.remove('is-open');
                  from.close();
                  document.documentElement.classList.remove('zv-no-scroll');
                }
              }
              ZV.bindDialog(target);
              ZV.openDialog(target, btn.hasAttribute('data-zv-swap') ? document.querySelector('.zv-header__menu-btn') : btn);
            });
          });
          document.querySelectorAll('dialog.zv-dialog').forEach((d) => window.ZV && ZV.bindDialog(d));
          this.bindSearch();
        }

        bindSearch() {
          const input = document.getElementById('zv-search-input');
          const results = document.querySelector('[data-zv-search-results]');
          const fallback = document.querySelector('[data-zv-search-default]');
          if (!input || !results || input.__zvBound) return;
          input.__zvBound = true;
          let timer;
          let controller;

          const render = (items, term) => {
            results.replaceChildren();
            if (!items.length) {
              const p = document.createElement('p');
              p.className = 'zv-search__empty';
              p.textContent = term ? `${window.zvStrings?.noResults || 'No results for'} “${term}”` : '';
              results.append(p);
            }
            items.forEach((item) => {
              const a = document.createElement('a');
              a.className = 'zv-search__hit';
              a.href = item.url;
              const imgWrap = document.createElement('span');
              imgWrap.className = 'zv-search__hit-img';
              const src = item.featured_image && item.featured_image.url;
              if (src) {
                const img = document.createElement('img');
                img.src = src + (src.includes('?') ? '&' : '?') + 'width=360';
                img.alt = '';
                img.loading = 'lazy';
                imgWrap.append(img);
              }
              const t = document.createElement('span');
              t.className = 'zv-search__hit-title';
              t.textContent = item.title;
              const pr = document.createElement('span');
              pr.className = 'zv-search__hit-price';
              pr.textContent = item.price ? new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(item.price) : '';
              a.append(imgWrap, t);
              if (item.price) a.append(pr);
              results.append(a);
            });
            if (items.length) {
              const all = document.createElement('a');
              all.className = 'zv-link zv-search__all';
              all.href = `${window.routes.predictive_search_url.replace('/suggest', '')}?q=${encodeURIComponent(term)}`;
              all.textContent = window.zvStrings?.viewAll || 'View all results';
              results.append(all);
            }
          };

          input.addEventListener('input', () => {
            clearTimeout(timer);
            const term = input.value.trim();
            if (term.length < 2) {
              results.hidden = true;
              fallback.hidden = false;
              return;
            }
            timer = setTimeout(async () => {
              controller?.abort();
              controller = new AbortController();
              try {
                const url = `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
                const res = await fetch(url, { signal: controller.signal });
                const data = await res.json();
                const items = data.resources?.results?.products || [];
                fallback.hidden = true;
                results.hidden = false;
                render(items, term);
              } catch (err) {
                if (err.name !== 'AbortError') results.hidden = true;
              }
            }, 220);
          });
        }
      }
    );
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-zv-langmenu][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-zv-langmenu][open]').forEach(function (d) {
      d.removeAttribute('open');
      d.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-main-product"]) return;
  try {
    
  if (!customElements.get('zv-product')) {
    customElements.define(
      'zv-product',
      class ZVProduct extends HTMLElement {
        connectedCallback() {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
          else this.init();
        }

        init() {
          if (this.__init) return;
          this.__init = true;
          this.variants = JSON.parse(this.querySelector('[data-zv-json]').textContent || '[]');
          this.form = this.querySelector('[data-zv-form]');
          this.sectionId = this.dataset.sectionId;
          this.fetchId = 0;

          this.form.addEventListener('change', (e) => {
            if (e.target.closest('.zv-option')) this.onOptionChange();
          });
          this.form.addEventListener('submit', (e) => this.onSubmit(e));
          this.bindQuantity();
          this.bindBundles();
          this.bindSticky();
          this.bindGallery();
          this.markAvailability();
        }

        /* ---------- quantity */
        bindQuantity() {
          const wrap = this.querySelector('[data-zv-qty]');
          if (!wrap) return;
          const input = wrap.querySelector('input');
          wrap.querySelector('[data-zv-qty-minus]').addEventListener('click', () => {
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          });
          wrap.querySelector('[data-zv-qty-plus]').addEventListener('click', () => {
            input.value = (parseInt(input.value, 10) || 1) + 1;
          });
          input.addEventListener('change', () => {
            input.value = Math.max(1, parseInt(input.value, 10) || 1);
          });
        }

        /* ---------- bundle tiers (tag zv-bundle): the chosen tier is the quantity */
        bindBundles() {
          const qty = this.querySelector('[data-zv-bundle-qty]');
          if (!qty) return;
          this.querySelectorAll('.zv-bundle__input').forEach((input) => {
            input.addEventListener('change', () => {
              if (input.checked) qty.value = input.value;
            });
          });
        }

        /* ---------- variants */
        selectedOptions() {
          return [...this.querySelectorAll('.zv-option')].map((fs) => {
            const checked = fs.querySelector('input:checked');
            return checked ? checked.value : null;
          });
        }

        findVariant(selected) {
          return this.variants.find((v) => selected.every((val, i) => v['option' + (i + 1)] === val));
        }

        markAvailability() {
          const selected = this.selectedOptions();
          this.querySelectorAll('.zv-option').forEach((fs, i) => {
            fs.querySelectorAll('input').forEach((input) => {
              const test = selected.slice();
              test[i] = input.value;
              const match = this.findVariant(test);
              if (!match || !match.available) input.setAttribute('data-unavailable', '');
              else input.removeAttribute('data-unavailable');
            });
          });
        }

        onOptionChange() {
          const selected = this.selectedOptions();
          this.querySelectorAll('.zv-option').forEach((fs, i) => {
            const label = fs.querySelector('[data-zv-selected]');
            if (label) label.textContent = selected[i] || '';
          });
          this.markAvailability();
          const variant = this.findVariant(selected);
          this.setError('');
          if (!variant) {
            this.setUnavailable();
            return;
          }
          this.querySelector('[data-zv-variant-id]').value = variant.id;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          this.scrollToVariantMedia(variant);
          this.refreshFromServer(variant.id);
        }

        setUnavailable() {
          const btn = this.querySelector('[data-zv-atc]');
          btn.disabled = true;
          btn.querySelector('[data-zv-atc-label]').textContent = window.variantStrings ? window.variantStrings.unavailable : 'Unavailable';
          const sticky = this.querySelector('[data-zv-sticky-btn]');
          if (sticky) sticky.disabled = true;
        }

        refreshFromServer(variantId) {
          const id = ++this.fetchId;
          const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.sectionId}`;
          fetch(url)
            .then((r) => r.text())
            .then((html) => {
              if (id !== this.fetchId) return;
              const doc = new DOMParser().parseFromString(html, 'text/html');
              ['[data-zv-price]', '[data-zv-sticky-price]', '[data-zv-bundle-price="1"]', '[data-zv-bundle-price="2"]', '[data-zv-bundle-price="3"]'].forEach((sel) => {
                const from = doc.querySelector(sel);
                const to = this.querySelector(sel);
                if (from && to) to.innerHTML = from.innerHTML;
              });
              const nextBtn = doc.querySelector('[data-zv-atc]');
              const btn = this.querySelector('[data-zv-atc]');
              if (nextBtn && btn) {
                btn.disabled = nextBtn.disabled;
                btn.querySelector('[data-zv-atc-label]').textContent = nextBtn.querySelector('[data-zv-atc-label]').textContent;
              }
              const nextSticky = doc.querySelector('[data-zv-sticky-btn]');
              const sticky = this.querySelector('[data-zv-sticky-btn]');
              if (nextSticky && sticky) {
                sticky.disabled = nextSticky.disabled;
                sticky.textContent = nextSticky.textContent.trim();
              }
            })
            .catch(() => {});
        }

        /* ---------- add to cart */
        setError(msg) {
          const el = this.querySelector('[data-zv-error]');
          if (!el) return;
          el.textContent = msg;
          el.hidden = !msg;
        }

        onSubmit(e) {
          if (!window.ZV) return;
          e.preventDefault();
          const btn = this.querySelector('[data-zv-atc]');
          if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;
          const label = btn.querySelector('[data-zv-atc-label]');
          const original = label.textContent;
          btn.setAttribute('aria-busy', 'true');
          this.setError('');
          const data = new FormData(this.form);
          // strip radio inputs that are not part of the cart payload
          [...data.keys()].filter((k) => k.startsWith('zv-')).forEach((k) => data.delete(k));
          ZV.addToCart(data)
            .then(() => {
              label.textContent = window.zvStrings && window.zvStrings.added ? window.zvStrings.added : 'Added';
              setTimeout(() => (label.textContent = original), 1800);
            })
            .catch((err) => {
              this.setError(err.message || (window.cartStrings && window.cartStrings.error) || '');
            })
            .then(() => btn.removeAttribute('aria-busy'));
        }

        /* ---------- sticky bar */
        bindSticky() {
          const bar = this.querySelector('[data-zv-sticky]');
          const atc = this.querySelector('[data-zv-atc]');
          if (!bar || !atc || !('IntersectionObserver' in window)) return;
          const btn = bar.querySelector('[data-zv-sticky-btn]');
          const io = new IntersectionObserver(
            ([entry]) => {
              const show = !entry.isIntersecting;
              bar.classList.toggle('is-visible', show);
              bar.setAttribute('aria-hidden', show ? 'false' : 'true');
              btn.tabIndex = show ? 0 : -1;
            },
            { threshold: 0 }
          );
          io.observe(atc);
          btn.addEventListener('click', () => this.form.requestSubmit());
        }

        /* ---------- gallery */
        scrollToVariantMedia(variant) {
          if (!variant.featured_media) return;
          const target = this.querySelector(`.zv-gallery__item[data-media-id="${variant.featured_media.id}"]`);
          const track = this.querySelector('[data-zv-track]');
          if (!target || !track) return;
          if (window.matchMedia('(min-width: 990px)').matches) {
            const r = target.getBoundingClientRect();
            if (r.bottom < 0 || r.top > window.innerHeight) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }

        bindView() {
          const gallery = this.querySelector('[data-zv-gallery]');
          const box = this.querySelector('[data-zv-model]');
          const opts = this.querySelectorAll('[data-zv-view]');
          if (!gallery || !box || !opts.length) return;
          const show = (mode) => {
            const is3d = mode === '3d';
            opts.forEach((o) => o.setAttribute('aria-pressed', String(o.dataset.zvView === mode)));
            if (is3d) {
              // match the first photo so the page does not jump
              const first = gallery.querySelector('.zv-gallery__item:not([hidden])');
              if (first && first.offsetHeight) box.style.setProperty('--zv-model-ar', `${first.offsetWidth} / ${first.offsetHeight}`);
              const tpl = box.querySelector('[data-zv-model-tpl]');
              if (tpl) {
                box.prepend(tpl.content.cloneNode(true));
                tpl.remove();
                if (!customElements.get('model-viewer') && window.Shopify && Shopify.loadFeatures) {
                  Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12' }]);
                }
              }
            }
            box.hidden = !is3d;
            gallery.classList.toggle('is-3d', is3d);
          };
          opts.forEach((o) => o.addEventListener('click', () => show(o.dataset.zvView)));
        }

        bindGallery() {
          const track = this.querySelector('[data-zv-track]');
          const dots = this.querySelectorAll('.zv-gallery__dot');
          if (track && dots.length && 'IntersectionObserver' in window) {
            const items = [...track.children];
            const io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                    const i = items.indexOf(entry.target);
                    dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
                  }
                });
              },
              { root: track, threshold: [0.6] }
            );
            items.forEach((el) => io.observe(el));
          }

          this.bindView();

          const box = this.querySelector('[data-zv-lightbox]');
          if (!box) return;
          const lbTrack = box.querySelector('[data-zv-lightbox-track]');
          const count = box.querySelector('[data-zv-lightbox-count]');
          const slides = [...lbTrack.children];
          this.querySelectorAll('[data-zv-zoom]').forEach((btn) => {
            btn.addEventListener('click', () => {
              if (!window.ZV) return;
              ZV.bindDialog(box);
              ZV.openDialog(box, btn);
              const i = slides.findIndex((s) => s.dataset.zvIndex === btn.dataset.zvZoom);
              requestAnimationFrame(() => {
                lbTrack.scrollLeft = Math.max(0, i) * lbTrack.clientWidth;
                count.textContent = `${Math.max(0, i) + 1} / ${slides.length}`;
              });
            });
          });
          lbTrack.addEventListener(
            'scroll',
            () => {
              const i = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth);
              count.textContent = `${i + 1} / ${slides.length}`;
            },
            { passive: true }
          );
          box.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') lbTrack.scrollBy({ left: lbTrack.clientWidth, behavior: 'smooth' });
            if (e.key === 'ArrowLeft') lbTrack.scrollBy({ left: -lbTrack.clientWidth, behavior: 'smooth' });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-soaps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zv-soaps')) {
    customElements.define(
      'zv-soaps',
      class ZVSoaps extends HTMLElement {
        connectedCallback() {
          this.shots = Array.prototype.slice.call(this.querySelectorAll('[data-soap-shot]'));
          this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-soap-row]'));
          if (this.shots.length < 2) return;
          this.index = 0;
          const self = this;
          this.rows.forEach(function (row, i) {
            row.addEventListener('mouseenter', function () { self.show(i); self.stop(); });
            row.addEventListener('focus', function () { self.show(i); self.stop(); });
          });
          this.addEventListener('mouseleave', function () { self.start(); });

          // Touch screens have no hover: rotate the shots while the section is on screen.
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
              self.visible = entries[0].isIntersecting;
              if (self.visible) self.start(); else self.stop();
            }, { threshold: 0.35 }).observe(this);
          }
        }

        show(i) {
          if (i === this.index || !this.shots[i]) return;
          this.index = i;
          this.shots.forEach(function (s, n) {
            s.classList.toggle('is-active', n === i);
            s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
          });
          this.rows.forEach(function (r, n) { r.classList.toggle('is-active', n === i); });
        }

        start() {
          if (this.reduce || this.timer || !this.visible) return;
          const self = this;
          this.timer = setInterval(function () { self.show((self.index + 1) % self.shots.length); }, 3200);
        }

        stop() {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
